import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { SystemType } from 'src/app/shared/models/system-type';
import { SystemTypesApiService } from 'src/app/core/services/http/system-types-api.service';
import AutoMapperService from './auto-mapper.service';
import { SystemTypeResponse } from '../../models/system-type response';

@Injectable({
    providedIn: 'root'
})
export class SystemTypesService {
    constructor(private api: SystemTypesApiService) {}
    private cachedSystemTypes: SystemType[] | null;

    getSystemTypes(): Observable<SystemType[]> {
        if (this.cachedSystemTypes) {
            return of(this.cachedSystemTypes);
        }
        return this.api.getSystemTypes().pipe(
            map(response => {
                this.cachedSystemTypes =
                    response?.map(data =>
                        AutoMapperService.mapToApplicationModel<SystemTypeResponse, SystemType>(data)
                    ) ?? [];
                return this.cachedSystemTypes;
            }),
            catchError(error => {
                this.clearCache();
                return throwError(() => error);
            })
        );
    }

    public clearCache() {
        this.cachedSystemTypes = null;
    }
}
